import { trackEvent } from './tracking';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Selectors
import * as WorkspaceMeetingModeSelectors from 'Shared/selectors/WorkspaceMeetingMode.selectors';

// Helpers
import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

export const useMeetingModeTracking = () => {
  const { workspaceId } = useParams();

  const { id: currentUserId } = useCurrentUser();
  const activeMeetingMode = useSelector(state =>
    WorkspaceMeetingModeSelectors.getWorkspaceMeetingModeItemByWorkspaceSlug(state, { workspaceSlug: workspaceId })
  );
  const participantIds = WorkspaceMeetingModeHelper.getParticipantIds(activeMeetingMode);
  const meetingModeSessionId = WorkspaceMeetingModeHelper.getId(activeMeetingMode);

  const { appId } = useApp();

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      product_feature: 'Workspace',
      sub_product_feature: 'Meeting Mode',
      user: currentUserId,
      meeting_id: meetingModeSessionId,
      participants: participantIds.size,
      app_id: appId,
      meeting_mode_version: '2',
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackNextClick = ({ isCompleteChecked }) => {
    track({ eventName: 'Clicked next in meeting mode', properties: { is_complete_checked: isCompleteChecked } });
  };

  const trackPreviousClick = () => {
    track({ eventName: 'Clicked previous in meeting mode' });
  };

  const trackAgendaItemClick = ({ isWrapUp }) => {
    track({ eventName: 'Clicked agenda item in meeting mode', properties: { is_wrap_up_item: isWrapUp } });
  };

  const trackViewAttendees = () => {
    track({ eventName: 'Viewed attendees in meeting mode' });
  };

  const trackSawStartScreen = ({ isFirstTimeUser }) => {
    track({ eventName: 'Saw meeting mode start screen', properties: { is_first_time_user: isFirstTimeUser } });
  };

  return { trackNextClick, trackPreviousClick, trackAgendaItemClick, trackViewAttendees, trackSawStartScreen };
};
